<template>
    <div :id="'module-image-' + dModule.id">
        <a
            v-if="dModule.data.redirect"
            :href="dModule.data.redirectTarget"
            :target="dModule.data.redirectType"
        >
            <img class="responsive" :src="dModule.data.image" />
        </a>

        <img v-else class="responsive" :src="dModule.data.image" />
    </div>
</template>

<script>
export default {
    name: "ImageModule",
    props: {
        data: Object,
    },
    data() {
        return {
            dModule: this.data,
        };
    },
};
</script>

<style scoped>
.responsive {
    position: relative;
    overflow: hidden;
    flex: 1 0 auto;
    display: flex;
    width: 100%;
    height: 100%;
}
</style>
